var render, staticRenderFns
import script from "./YearlyIncomeChart.vue?vue&type=script&lang=js&"
export * from "./YearlyIncomeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d45f132",
  null
  
)

export default component.exports